export default __webpack_public_path__ + "static/media/print.250faba5.svg";